<div>
    <div>
        <app-collapse-button [isActive]="!isEditable" (click)='collapse()'></app-collapse-button>
        <app-reload-button-sm [isActive]="!isEditable && !isLoading" [isLoading]="isLoading" (click)="reload()"></app-reload-button-sm>
        <app-add-button-sm [isActive]="!isEditable && !isLoading" (click)='add()'></app-add-button-sm>
        <div (click)='collapse()' class='group-title' style='cursor: pointer;'>
            Vendors
            <div *ngIf="!isLoading" class='results'>({{courseVendors.length}})</div>
        </div>
    </div>
</div>

<div [ngClass]="{'hide':!display}">

    <app-loading [isLoading]="isLoading" *ngIf="isLoading"></app-loading>

    <div *ngIf="!isLoading">
        <div *ngIf='isAdd'>
            <div class='index'>
                <div class='row title' style='display:none;'></div>
                <div>
                    <app-course-vendor></app-course-vendor>
                </div>
            </div>
        </div>

        <div [ngClass]="{hide: isAdd}">
            <div class='text-center alert-text' *ngIf="errorMessage">
                {{errorMessage}}
            </div>

            <div *ngIf="!errorMessage">
                <div class='instructions' *ngIf='courseVendors.length === 0'>
                    No Vendors are associated with this Course.
                </div>

                <div class='instructions' *ngIf='courseVendors.length > 0'>
                    Listed below are the Vendors associated with this Course.
                </div>

                <div class='index'>

                    <div class='row title'>
                        <div class='col-sm-1'>ID</div>
                        <div class='col-sm-11'>Name</div>
                    </div>

                    <div class='row' *ngIf='courseVendors.length === 0'>
                        <div class='col-sm-12 text-center'>
                            There are no Vendors to report for this Course.
                        </div>
                    </div>

                    <div *ngFor="let courseVendor of courseVendors" class='row'>
                        <app-course-vendor [courseVendor]="courseVendor"></app-course-vendor>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>